// extracted by mini-css-extract-plugin
export default {"wrapper":"Legend_wrapper__JadCJ","legendGroup":"Legend_legendGroup__uFzfA","legendItem":"Legend_legendItem__kcw-y"};